var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGrammar({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.125h2.25c.827 0 1.5-.673 1.5-1.5v-2.25a.736.736 0 00-.024-.188A.736.736 0 008.25 9V7.125A1.877 1.877 0 006.375 5.25h-1.5c-.5 0-.97.195-1.325.55a.75.75 0 101.06 1.06.374.374 0 01.265-.11h1.5c.207 0 .375.168.375.375V8.25h-1.5C4.01 8.25 3 9.26 3 10.5v1.125c0 .827.673 1.5 1.5 1.5zm0-2.625a.75.75 0 01.75-.75h1.5v1.875H4.5V10.5zM12.75 7.5h-1.875v-3a.75.75 0 00-1.5 0v7.875c0 .414.336.75.75.75h2.625a1.877 1.877 0 001.875-1.875V9.375A1.877 1.877 0 0012.75 7.5zm.375 3.75a.375.375 0 01-.375.375h-1.875V9h1.875c.207 0 .375.168.375.375v1.875zM20.25 11.625h-1.875c-.62 0-1.125-.505-1.125-1.125V9.375c0-.62.505-1.125 1.125-1.125h1.875a.75.75 0 000-1.5h-1.875a2.628 2.628 0 00-2.625 2.625V10.5a2.628 2.628 0 002.625 2.625h1.875a.75.75 0 000-1.5zM12 21a.747.747 0 00.53-.22l5.25-5.25a.75.75 0 10-1.06-1.06L12 19.19l-2.845-2.845a.75.75 0 00-1.06 1.06l3.375 3.375c.146.147.338.22.53.22z"
  })));
}

export default SvgGrammar;